import { SensitiveDataFormField } from "types/Models/sensitiveData";
import { isSensitiveDataFieldVisible } from "util/isSensitiveDataFieldVisible";
import { manualBankAccountSchema } from "formValidations/manualBankAccountSchema";
import {
  SENSITIVE_DATA_BANK_ENTRY_MODE,
  SENSITIVE_DATA_BANK_ENTRY_MODE_KEY,
  SENSITIVE_DATA_MANUAL_BANK_KEY,
} from "constants/sensitiveData";
import { AnySchema, mixed, object, string } from "yup";

export const createDynamicValidationSchema = (
  fields: SensitiveDataFormField[]
) => {
  const shape: Record<string, AnySchema> = {};

  fields.forEach((field: SensitiveDataFormField) => {
    const requiredMessage = `${field.key} is required`;

    switch (field.data_type) {
      case "STRING":
      case "TEXTAREA":
      case "SELECT":
      case "ENTITY":
      case "PERSONA":
      case "BANK_ACCOUNT":
        shape[field.field_key] = string()
          .nullable()
          .test(
            "required-when-visible",
            requiredMessage,
            function requiredWhenVisible(value) {
              if (!field.is_required) return true;
              if (!isSensitiveDataFieldVisible(field, this.parent)) return true;

              const isManualBankEntry =
                field.data_type === "BANK_ACCOUNT" &&
                this.parent[SENSITIVE_DATA_BANK_ENTRY_MODE_KEY] ===
                  SENSITIVE_DATA_BANK_ENTRY_MODE.MANUAL;

              if (isManualBankEntry) return true;

              return Boolean(value);
            }
          );
        break;
      case "MULTI_FILE_INPUT":
        shape[field.field_key] = mixed().test(
          "required-when-visible",
          requiredMessage,
          function requiredWhenVisible(value) {
            if (!field.is_required) return true;
            if (!isSensitiveDataFieldVisible(field, this.parent)) return true;

            return Boolean(value);
          }
        );
        break;
      default:
        shape[field.field_key] = mixed().nullable();
    }
  });

  const hasBankField = fields.some(
    ({ data_type }) => data_type === "BANK_ACCOUNT"
  );

  if (!hasBankField) return object().shape(shape);

  shape[SENSITIVE_DATA_MANUAL_BANK_KEY] = manualBankAccountSchema.when(
    SENSITIVE_DATA_BANK_ENTRY_MODE_KEY,
    {
      is: SENSITIVE_DATA_BANK_ENTRY_MODE.MANUAL,
      otherwise: (schema) => schema.strip(),
    }
  ) as unknown as AnySchema;

  shape[SENSITIVE_DATA_BANK_ENTRY_MODE_KEY] = string().nullable();

  return object().shape(shape);
};
